export default "__VITE_ASSET__DMBynErs__"